import { IVideoTutorialsState } from 'domain/videoTutorials/types';
import { createStandardAction } from 'typesafe-actions';

export const videoTutorialsSetActions =
  createStandardAction('ENV_VIDEO_TUTORIALS_SET')<IVideoTutorialsState>();
